import { render } from "./ApprovalForm.vue?vue&type=template&id=c8375172&scoped=true"
import script from "./ApprovalForm.vue?vue&type=script&lang=js"
export * from "./ApprovalForm.vue?vue&type=script&lang=js"

import "./ApprovalForm.vue?vue&type=style&index=0&id=c8375172&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8375172"],['__file',"src/views/h5/common/approval/ApprovalForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c8375172"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c8375172', __exports__)) {
    api.reload('c8375172', __exports__)
  }
  
  module.hot.accept("./ApprovalForm.vue?vue&type=template&id=c8375172&scoped=true", () => {
    api.rerender('c8375172', render)
  })

}


export default __exports__